module.exports = __webpack_public_path__ + "static/img/red-envelope.bea1b1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/limit-activity/red-envelope.png
// module id = 9RVO
// module chunks = 216